<template>
<div id="account-settings" style="display:none;">
	<div id="account-settings-header" style="padding:0">
		<div style="width:40%; float:left;">
			<h5>Account Management</h5>
			<p>Account: <span class="account-name">{{ account.priv.name }}</span>, <span class="account-email">{{ obfuscatedEmail }}</span></p>
			<p>
				<a class="req-change-email" :class="changeEmailSubmitting ? 'disabled' : ''" @click.prevent="changeEmail">Change Email</a> | <a class="req-change-password" :class="changePasswordSubmitting ? 'disabled' : ''" @click.prevent="changePassword">Change Password</a>
			</p>
			<p v-html="responseMsg" />
		</div>
		<div style="width:60%; float:left; border-top:none; color:black;" class="payment-portal">
			<div style="float:left; max-width:40%" class="center-text">
				<div class="checkout">
					<div class="amount">
						<h6>Choose Amount</h6>
						$<input id="checkout-amount" v-model="creditAmount" inputmode="tel" placeholder="Amount in USD" maxlength="5" min="15" step="5" style="width:25%;"> for <a v-if="!creditTarget" @click="lookupUser">yourself</a>
						<user-name v-else-if="creditTarget" :user="creditTarget" :account="false" />
						<div v-if="creditTarget">
							<a @click="creditTarget = false">Switch back to self</a>
							<input v-model="creditMsg" type="text" placeholder="Gift Message (optional)" maxlength="64">
						</div>
						<p class="red-text">
							{{ purchaseError }}
						</p>
					</div>
					<div class="via">
						<a class="button via-stripe pops-up" style="padding:0.5em;" @click="purchaseCredit"><h5 style="color:white">Continue With Payment<p style="font-size:50%;">Credit/Debit</p></h5></a>
						<!--<a class="button via-dwolla" style="padding:0.5em;"><h5 style="color:white">Dwolla</h5></a>
								<p>(ACH bank xfer. $5 minimum)</p>-->
						<div id="purchase" class="to-pop-up">
							<div class="sr-root clear">
								<div class="sr-main">
									<p style="color:#1f2225; margin-bottom:0.5em">
										Purchasing <strong>${{ creditAmount }}</strong> toward <span v-if="!creditTarget">your</span><span v-else-if="creditTarget">{{ creditTarget.props.name }}'s</span> Credits<span v-if="creditMsg"> with the gift message: {{ creditMsg }}</span>
									</p>
									<form class="sr-payment-form">
										<div class="sr-combo-inputs-row">
											<div id="purchase-card-element" class="sr-input sr-card-element" />
										</div>
										<div class="sr-field-error card-errors" role="alert" />
										<button class="submit">
											<div class="spinner hidden" />
											<span class="button-text">Pay</span><span id="order-amount" />
										</button>
									</form>
									<p style="color:#1f2225;">
										Your credit card information is not saved, and is sent directly to the card processor
									</p>
								</div>
							</div>
							<p><a class="error closer">Cancel</a></p>
						</div>
					</div>
				</div>
			</div>
			<h5>Credit: $<span class="creds">{{ creditDollars }}</span> | Lifetime Total: $<span class="creds">{{ lifetimeCreditDollars }}</span></h5>
			<p class="account-donator" v-html="accessMsg" />
		</div>
	</div>
	<div class="chars-list no-border" style="clear:left; padding:0;">
		<div style="clear:both; width:40%; float:left">
			<div v-if="showPerks && displayablePerks">
				<h6>Perks</h6>
				<p
					v-for="(perk) in displayablePerks"
					:key="perk"
				>
					<span>{{ perk.human_readable + (perk.count > 1 ? 's' : '') }}</span>
					<span
						v-if="!perk.exclusive"
					>: {{ perk.usages_count }}/{{ perk.count }}
						<a v-if="perk.subscriber_increase"
							class="help"
							:title=" perk.count + ' permanent ' + perk.human_readable + ' slots. ' + ( account.props.sub ? 'This has been ncreased by 5x for being a God-mode Subscriber, plus 5 for being a God-mode Subscriber' : 'You can increase this limit by 5x by being a God-mode Subscriber' )"
						>?</a>
					</span>
				</p>
			</div>
			<h6>
				Characters ({{ account.userids.length }}/{{ account.priv.maxChars }} slots used) | <a class="increase-char-slots pops-up" :class="account.users.length < account.priv.maxChars ? '' : 'bold'">Add additional slots</a>
				<div class="to-pop-up">
					<p>Current Credit: ${{ creditDollars }}</p>
					<p>Adding 10 character slots will cost</p>
					<p><strong style="font-size:400%;">${{ slotsIncreaseCost }}</strong></p>
					<p>This cost increases for every<br>50 character slots you have.</p>
					<p><a v-if="parseInt(slotsIncreaseCost).toFixed(2) <= parseInt(creditDollars)" class="closer" @click="increaseMaxSlots">Confirm Purchase</a><strong v-else-if="parseInt(slotsIncreaseCost).toFixed(2) > parseInt(creditDollars)">More credit required</strong> / <a class="error closer">Cancel</a></p>
				</div>
			</h6>
			<ul>
				<li v-show="account.users.length < account.priv.maxChars"
					style="min-height:30px; padding-top:5px;"
					@mouseenter="hoverChar = true" @mouseleave="hoverChar = false"
				>
					<a v-show="!hoverChar">Create a New Character</a>
					<p v-show="hoverChar">
						<input v-model="newCharName" placeholder="New Character Name" :disabled="submitting" @keyup.enter="addNewChar"><input type="submit" value="+" :disabled="submitting" @click="addNewChar">
					</p>
					<p class="add-char-error">
						{{ (addCharError || '&nbsp;') }}
					</p>
				</li>
				<li class="flex">
					<button class="sort-button vanishing" title="Sort by favorites"
						@click.prevent="sortCharactersFavorites()"
					>
						<p>
							⬇
							<span v-show="sortBy === 'favorites'"
								class="sort-key"
							>
								<span>★</span>
								<span>☆</span>
							</span>
							<span v-show="sortBy !== 'favorites'"
								class="sort-key"
							>
								<span>☆</span>
								<span>★</span>
							</span>
						</p>
					</button>
					<button class="sort-button vanishing" title="Sort alphabetically"
						@click.prevent="sortCharactersAlphabetical()"
					>
						<p>
							⬇
							<span v-show="sortBy === 'alphabetical'"
								class="sort-key"
							>
								<span>A</span>
								<span>Z</span>
							</span>
							<span v-show="sortBy !== 'alphabetical'"
								class="sort-key"
							>
								<span>Z</span>
								<span>A</span>
							</span>
						</p>
					</button>
					<button class="right vanishing"
						@click.prevent="openGlobalBadgeSetter()"
					>
						Set badges on all characters
					</button>
				</li>
				<li
					v-for="(user, index) in account.users"
					:key="user"
					style="clear:both;"
					class="char-listing"
				>
					<span class="index">{{ index+1 }}</span>
					<user-line :user="user" :account="account" :editanddel="true" :room="false" />
				</li>
			</ul>
		</div>
		<div style="width:60%; float:left; color:black;" class="subscribe-features" @mouseenter="$refs.video.play()" @mouseleave="$refs.video.pause()">
			<div class="flex-parent">
				<div class="center-text">
					<div v-show="!account.props.sub && !account.props.resub">
						<a class="button pops-up" style="padding:0.5em;" @click="purchaseSubscription"><h5>$14.98</h5>per 2 months</a>
						<div id="subscribe" class="to-pop-up">
							<div class="sr-root">
								<div class="sr-main">
									<p style="color:#1f2225;; margin-bottom:0.5em">
										<strong>$14.98</strong> every 2 months, reoccuring
									</p>
									<form class="sr-payment-form">
										<div class="sr-combo-inputs-row">
											<div id="subscribe-card-element" class="sr-input sr-card-element" />
										</div>
										<div class="sr-field-error card-errors" role="alert" />
										<button class="submit">
											<div class="spinner hidden" />
											<span class="button-text">Subscribe</span><span id="order-amount" />
										</button>
										<p style="color:#1f2225;">
											Your credit card information is not saved, and is sent directly to the card processor
										</p>
									</form>
								</div>
							</div>
							<p><a class="error closer">Cancel</a></p>
						</div>
					</div>
					<div v-show="account.props.sub && account.props.resub">
						<p>Next automatic payment:</p>
						<p>{{ makeTimestamp(account.priv.subscribeEnd*1000) }}</p>
						<a class="pops-up">Cancel Subscription</a>
						<div class="to-pop-up">
							<p>Are you sure you wish to cancel? You will lose your original subscribed at date on your badge, and the next time you start a new subscription the badge will be reset to that later date.</p>
							<p>Upon cancellation, your subscription will continue until {{ makeTimestamp(account.priv.subscribeEnd*1000) }}, at which point it will <em>not</em> renew automatically.</p>
							<p><a class="closer" @click="cancelSubscription">Confirm Cancelation</a> / <a class="error closer">Cancel</a></p>
						</div>
					</div>
					<div v-show="account.props.sub && !account.props.resub">
						<p>Subscription ends:</p>
						<p>{{ makeTimestamp(account.priv.subscribeEnd*1000) }}</p>
						<a @click="reenableSubscriptionRenewal">Re-enable autorenewal</a>
					</div>
					<!--<a>Gift 2 months</a>-->
				</div>
				<div v-show="!account.props.sub" class="padding-right">
					<h5>Subscribe now to <em>God Mode</em></h5>
					<h6>For $7.49 per month, upgrade your RPH with God Mode. Cancel anytime.</h6>
					<p style="font-size:70%">
						<em>But please refrain from god moding in your actual roleplays</em>
					</p>
				</div>
				<div v-show="account.props.sub" class="padding-right">
					<h5>You are currently subscribed to <em>RPH God Mode</em></h5>
				</div>
			</div>
			<div class="flex-parent flex-wrap clear">
				<div class="perk flex-responsive">
					<h6>All the Names</h6>
					<p>Set any character name to anything you want, at any time. Minimal limits on usable symbols.</p>
				</div>
				<div class="perk flex-responsive">
					<h6>Sick Fade</h6>
					<p>Can't chose between <span style="color:#50d6e4">Saiyan Blue</span>, <span style="color:#dc098e">Saiyan God</span>, and <span style="color:#f5beda">Saiyan Rose</span>? <span class="saiyan-fade">Mix them all together in various styles</span>.</p>
				</div>
				<div class="perk flex-responsive">
					<h6>Do a Flip</h6>
					<p>Add a coin flip animation for your coin flip rolls.</p>
				</div>
				<div class="perk flex-responsive">
					<h6>More Frames for More Character</h6>
					<p>5 Animated Banner slots, and a 5x increase on your permanent Animated Banner slots.</p>
				</div>
				<div class="perk flex-responsive">
					<h6>Custom Emojis</h6>
					<p>Coming Soon: <span style="opacity:0.7">5 Custom Emoji slots to replace the standard Emoticon & Body emojis, and a 5x increase on your Custom Emoji slots.</span></p>
				</div>
				<div class="perk flex-responsive">
					<h6>Show Your Support</h6>
					<p>Obtain a badge to display how long you've been a subscriber. Enable it at will on any of your characters.</p>
				</div>
				<div class="perk flex-responsive">
					<h6>Unlock 'em All</h6>
					<p>Counts toward permanent unlock tiers. Your first subscription unlocks the $15 tier.</p>
				</div>
				<div class="perk flex-responsive">
					<h6>Become a Guinea Pig</h6>
					<p>Access to experimental features, which may be scrapped, before they're finalized.</p>
				</div>
				<div class="perk flex-responsive">
					<h6>More to Come!</h6>
					<p>More <em>God Mode</em> subscriber features will be added after group improvements.</p>
				</div>
			</div>
			<h5>Subscriber Choice</h5>
			<p>Every few months, Subscribers get additional bonuses to choose from, with each instance offering an exclusive option that is only available from that instance of Subscriber Choice</p>
			<div class="flex-parent flex-wrap">
				<div class="center-text flex-50percent flex-responsive">
					<h5 class="center-text">
						RPH without God Mode
					</h5>
					<div style="background: #362f32; padding: 0 0 0.5rem; display: inline-block; width:240px">
						<video width="240" height="120">
							<source src="https://img.rphaven.com/ring%20cropped%20240x120.webm" type="video/mp4">
						</video>
						<span class="name" style="color:#6D88B9;">Sadako</span>
					</div>
				</div>
				<div class="center-text flex-50percent flex-responsive">
					<h5>RPH <em>with</em> God Mode</h5>
					<div style="background: #362f32; color: var(--dark-bg-color); padding: 0 0 0.5rem; display: inline-block; width:240px">
						<video ref="video" width="240" height="120" loop="">
							<source src="https://img.rphaven.com/ring%20cropped%20240x120.webm" type="video/mp4">
						</video>
						<span class="name horizontal-fade three-color" style="--color1:#6D88B9; --color2:#B8CAED; --color3:#6D88B9;" title="Sadako">💨『𝕥𝕖𝕝𝕖𝕡𝕠𝕣𝕥𝕤 𝕓𝕖𝕙𝕚𝕟𝕕 𝕪𝕠𝕦』☠️</span>
						<p class="small">
							<em>a.k.a. Sadako</em>
						</p>
					</div>
					<p>There will be some limitations to which characters you can use in the future (ie no zalgo), so go easy on it</p>
				</div>
			</div>
			<h5>Permanent Unlock Tiers</h5>
			<p>Unlock these features permanently by buying credits to use for microtransactions, and/or by amounts paid toward subscriptions. A subscription does <em>not</em> give credit to spend toward microtransactions, but <em>will</em> count toward your total for unlock tiers.</p>
			<h6>Tier 1</h6>
			<p>$15 <em>or</em> 2 months subscribed, permanently unlocks:</p>
			<p>Unlimited Friends, Blocks, and Offline Messages Received, instead of 100, 50, and 10 respectively.</p>
			<p>100 maximum characters status message length, instead of only 20.</p>
			<h6>Tier 2</h6>
			<p>Tier 2 unlock is being phased out. Partial refunds will be offered for those who spent more than $15 recently to unlock Javascript on profiles and who want a refund.</p>
		</div>
	</div>
	<div v-show="account.deletedUsers.length > 0" class="chars-list no-border" style="clear:left;">
		<h6 style="width:50%; float:left;">
			Deleted Characters
		</h6>
		<div style="clear:both;">
			<span
				v-for="(user, index) in account.deletedUsers"
				:key="user"
				style="clear:both;"
				class="char-listing"
			>
				<span v-show="index > 0">{{ ', ' }}</span><user-name :user="user" :account="account" />
			</span>
		</div>
	</div>
	<div>
		<h6>Transactions</h6>
		<p v-if="account.transactions.length == 0">
			No transactions to show here. These\'ll appear as you add or spend credit on your account.
		</p>
		<ul>
			<li
				v-for="(transaction) in account.transactions"
				:key="transaction"
			>
				<span v-if="transaction.change">${{ (transaction.change/10).toFixed(2) }}</span> {{ transaction.msg }} <span style="float:right">{{ makeTimestamp(transaction.date) }}</span>
			</li>
		</ul>
	</div>
</div>
</template>

<script>
import Username from '../components/user-name.vue'
import Userline from '../components/user-line.vue'
import perks from '../json/shared/perks.json'
import { makeTimestamp } from '../js/shared/common-functions.js'
import { increaseBySubscriberCount, getPerkUsages } from '../js/account-functions.js'
import { BASIC_USER, BONUS_PLUS_USER, ANIMATED_BONUS_PLUS_USER, FAKE_BONUS_PLUS_USER } from '../json/roles.json'
import { watch, reactive, ref } from 'vue'
import socket from '../js/socket.js'
import account from '../js/account.js'

let stripeClientSecret
if( window.location.pathname === '/' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1' ){
	stripeClientSecret = 'pk_live_erZTG9Sjl17g3eKp1EqlTNbP'
} else if( window.location.pathname === '/chattest.html' ){
	stripeClientSecret = 'pk_test_fNyNbnotd0v62zHy3BnwUL7W'
} else {
	stripeClientSecret = 'pk_test_fNyNbnotd0v62zHy3BnwUL7W'
}
const stripe = Stripe( stripeClientSecret ),

	 elements = stripe.elements(),
	style = {
		base: {
			color: '#32325d',
			fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
			fontSmoothing: 'antialiased',
			fontSize: '16px',
			'::placeholder': {
				color: '#aab7c4'
			}
		},
		invalid: {
			color: '#fa755a',
			iconColor: '#fa755a'
		}
	},
	card = elements.create( 'card', { style: style }),

	 changeLoadingState = function( isLoading ){
		if( isLoading ){
			$( '.payment-portal button' ).prop( 'disabled', true )
			$( '.payment-portal .spinner' ).show()
			$( '.payment-portal .button-text' ).hide()
		} else {
			$( '.payment-portal button' ).prop( 'disabled', false )
			$( '.payment-portal .spinner' ).hide()
			$( '.payment-portal .button-text' ).show()
		}
	},

		 showError = ( errorMsgText ) => {
		changeLoadingState( false )
		var errorMsg = $( '.sr-field-error' )
		errorMsg.text( errorMsgText )
		setTimeout( () => {
			errorMsg.text( '' )
		}, 4000 )
	}

export default {
	components: {
		'user-line': Userline,
		'user-name': Username
	},
	data: () => ({
		account,
		responseMsg: '&nbsp;',
		hovered: [],
		deleting: [],
		statuses: [],
		hoverChar: false,
		newCharName: null,
		addCharError: false,
		submitting: false,
		changePasswordSubmitting: false,
		changeEmailSubmitting: false,
		creditTarget: false,
		creditMsg: '',
		creditAmount: 15,
		purchaseError: '',
		perks: perks,
		sortBy: false
	}),
	computed: {
		displayablePerks(){
			const humanReadablePerks = Object.keys( this.account.priv.perks )
				.filter( ( perk ) => perks[perk] && perks[perk] !== 'CHARACTER_SLOT' )
				.reduce( ( obj, key ) => {
					const perkConst = perks[key],
						perk = perks[perkConst]
					let count = this.account.priv.perks[key]

					count = perk.subscriber_increase
						? increaseBySubscriberCount( count, this.account )
						: count
					const usages_count = getPerkUsages( perkConst, this.account )

					obj[key] = {
						usages_count,
						count,
						...perk
					}
					return obj
				}, {})
			return Object.values( humanReadablePerks )
		},
		thumbUrl: function(){
			return this.account.users.map( ( user ) => {
				if( user.props.iconExt === 'png' || user.props.iconExt === 'jpg' ){
					return '//img.rphaven.com/th_' + user.props.id + '.' + user.props.iconExt
				} else {
					return '//img.rphaven.com/th_noimage.png'
				}
			})
		},
		slotsIncreaseCost: function(){
			return ( parseInt( Math.ceil( ( this.account.priv.maxChars + 10 ) / 50 ) ) * 5 ).toFixed( 2 )
		},
		creditDollars: function(){
			return ( this.account.priv.credit / 10 ).toFixed( 2 )
		},
		lifetimeCreditDollars: function(){
			return Math.min( ( this.account.priv.totalCredit / 10 ), 45 ).toFixed( 2 ) +
					( ( this.account.priv.totalCredit / 10 > 45 )
						? '+'
						: '' )
		},
		accessMsg: function(){
			let msgToReturn = 'Your account is limited to basic features. Buying at least $15 of credit or a 2 month subscription will unlock tier 1 account priveledges.'
			if( this.account.props.access > BASIC_USER && this.account.props.access < BONUS_PLUS_USER ){
				if( this.account.props.access == FAKE_BONUS_PLUS_USER ){
					msgToReturn = 'You\'ve paid enough to unlock tier 1 account features. Thanks! <span class="red-text">❤️</span> You are also grandfathered into the profile javascript access before that was increased to a $45 paid+ account feature.'
				} else {
					msgToReturn = 'You\'ve paid enough to unlock tier 1 account features. Thanks! <span class="red-text">❤️</span>'
				}
			} else if( this.account.props.access >= BONUS_PLUS_USER ){
				if( this.account.props.access == ANIMATED_BONUS_PLUS_USER ){
					msgToReturn = 'You\'ve paid enough to unlock tier 2 account features. Thanks! <span class="red-text">💖</span> You are also grandfathered in to having an animated banner perk'
				} else {
					msgToReturn = 'You\'ve paid enough to unlock tier 2 account features. Thanks! <span class="red-text">💖</span>'
				}
			}
			return msgToReturn
		},
		obfuscatedEmail: function(){
			const email = this.account.priv.email
			return email.substring( 0, 1 ) + '...' + email.substring( email.indexOf( '@' ) - 3 )
		},
		showPerks(){
			return Object.keys( account.priv.perks ).length > 0
		}
	},
	watch: {
		creditAmount: {
			handler: function( val ){
				if( val < 15 ){
					this.purchaseError = '$15 minimum for credit card payments. I may add ACH payments back later...'
					setTimeout( () => {
						this.purchaseError = ''
					}, 4000 )
				} else {
					this.purchaseError = ''
				}
			}
		}
	},
	created(){
		const sendMailRequestMsg = 'request has been sent to your email. It may take a few minutes to arrive'

		socket.on( 'add-char-submit-complete', ( data ) => {
			this.submitting = false
		})
		socket.on( 'change-email-request-complete', ( data ) => {
			this.changeEmailSubmitting = false
			this.responseMsg = '<span class="green-text">Email change ' + sendMailRequestMsg + '</span>'
		})
		socket.on( 'change-password-request-complete', ( data ) => {
			this.changePasswordSubmitting = false
			this.responseMsg = '<span class="green-text">Password change ' + sendMailRequestMsg + '</span>'
		})
		socket.on( 'delete-char-request-complete', ( data ) => {
			this.responseMsg = '<span class="green-text">Character deletion ' + sendMailRequestMsg + '</span>'
		})

		card.addEventListener( 'change', function( event ){
			const $displayError = $( '#account-settings .card-errors' )
			if( event.error ){
				$displayError.text( event.error.message )
			} else {
				$displayError.text( '' )
			}
		})
	},
	methods: {
		openGlobalBadgeSetter(){
			$( '#set-badges-dialog' ).dialog( 'open' )
			$( '#set-badges-dialog' ).parent().find( 'span.ui-dialog-title' ).html( 'Select Badges to display globally' )
			$( '#set-badges-dialog' )[0].Vue.user = this.account.users
		},
		sortCharactersAlphabetical(){
			if( this.sortBy !== 'alphabetical' ){
				this.account.users = this.account.users.sort( ( user, prevUser ) => {
					return user.props.name.localeCompare( prevUser.props.name )
				})
				this.sortBy = 'alphabetical'
			} else {
				this.account.users = this.account.users.sort( ( user, prevUser ) => {
					return prevUser.props.name.localeCompare( user.props.name )
				})
				this.sortBy = 'alphabeticalReverse'
			}
		},
		sortCharactersFavorites(){
			if( this.sortBy !== 'favorites' ){
				this.account.users = this.account.users.sort( ( user ) => {
					return !account.settings.favUsers.includes( user.props.id ) ? 1 : -1
				})
				this.sortBy = 'favorites'
			} else {
				this.account.users = this.account.users.sort( ( user ) => {
					return account.settings.favUsers.includes( user.props.id ) ? 1 : -1
				})
				this.sortBy = 'favoritesReverse'
			}
		},
		cancelSubscription: function(){
			socket.emit( 'stripe-cancel-subscription', false, ( err, data ) => {
				if( err ) console.log( err )
			})
		},
		reenableSubscriptionRenewal: function(){
			socket.emit( 'stripe-uncancel-subscription', false, ( err, data ) => {
				if( err ) console.log( err )
			})
		},
		lookupUser: function( ev ){
			const thisVue = this
			var pointer = rph.PointerInput.attachTo( $( ev.target ) ).onSubmit( function(){
				getUserByName( this.val(), ( user ) => {
					thisVue.creditTarget = user
				})
			})
			pointer.$el.find( '.container' ).css( 'width', '330px' ).find( 'input' ).attr( 'placeholder', 'Character name to purchase for' )
		},
		purchaseSubscription: function(){
			card.unmount()
			card.mount( '#subscribe-card-element' )

			const pay = () => {
				changeLoadingState( true )

				stripe.createPaymentMethod( 'card', card )
					.then( function( result ){
						if( result.error ){
							showError( result.error.message )
						} else {
							return result.paymentMethod
						}
						// Handle result.error or result.paymentMethod
					}).then( ( paymentMethod ) => {
						socket.emit( 'stripe-create-customer', {paymentMethod: paymentMethod.id}, ( err, data ) => {
							if( err ){
								showError( err.message )
							} else {
								changeLoadingState( false )
								$( '#subscribe' ).hide()
							}
						})
					})
			}

			$( 'button' ).prop( 'disabled', false )
			$( '#subscribe form' ).off( 'submit' )
			$( '#subscribe form' ).on( 'submit', function( ev ){
				ev.preventDefault()
				pay()
			})
		},
		purchaseCredit: function(){
			const orderData = {
				currency: 'usd',
				amount: this.creditAmount,
				toUserid: this.creditTarget && this.creditTarget.props.id,
				msg: this.creditMsg,
				toName: this.creditTarget && this.creditTarget.props.name
			}
			socket.emit( 'stripe-create-payment-intent', orderData, ( err, data ) => {
				card.unmount()
				card.mount( '#purchase-card-element' )

				if( err ){
					showError( err.msg )
					return false
				}

				const clientSecret = data.clientSecret

				// Shows a success / error message when the payment is complete
				var orderComplete = function( clientSecret ){
					stripe.retrievePaymentIntent( clientSecret )
						.then( function( result ){
							var paymentIntent = result.paymentIntent,
							 paymentIntentJson = JSON.stringify( paymentIntent, null, 2 )

							changeLoadingState( false )
							$( '#purchase' ).hide()
						}).catch( ( err ) => console.log( 'retrievePaymentIntent err', err ) )
				}

				const pay = () => {
					changeLoadingState( true )

					stripe.confirmCardPayment( clientSecret, { // If authentication is required, confirmCardPayment will automatically display a modal
						payment_method: {
							card: card
						}
					}).then( function( result ){
						if( result.error ){
							showError( result.error.message )
						} else { // payment has been processed
							orderComplete( clientSecret )
						}
					}).catch( ( err ) => console.log( 'confirmCardPayment err', err ) )
				}

				$( 'button' ).prop( 'disabled', false )
				$( '#purchase form' ).off( 'submit' )
				$( '#purchase form' ).on( 'submit', function( ev ){
					ev.preventDefault()
					pay()
				})
			})
		},
		addNewChar: function( ev ){
			this.submitting = true
			socket.emit( 'add-char', {name: this.newCharName})
		},
		increaseMaxSlots: function(){
			socket.emit( 'increase-max-slots' )
		},
		changeEmail: function( ev ){
			if( !this.changeEmailSubmitting ){
				this.changeEmailSubmitting = true
				socket.emit( 'change-email' )
			}
		},
		changePassword: function( ev ){
			if( !this.changePasswordSubmitting ){
				this.changePasswordSubmitting = true
				socket.emit( 'change-password' )
			}
		},
		makeTimestamp: makeTimestamp
	}
}
</script>